import styled from 'styled-components';

export const Discount = styled.div`
  display: flex;
  border-radius: 8px;
  background-color: #00a3bf;
  padding: 4px;
  line-height: 18px;
  gap: 2px;
  height: 26px;
  width: fit-content;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: max-content;
  }
`;
